import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import FacilitiesEdit from './FacilitiesEdit';
import FloorPlansCreate from './FloorPlansCreate';
import CropFloorPlan from './CropFloorPlan';
import FloorPlansEdit from './FloorPlansEdit';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AreasProvider from '../../contexts/AreasContext';
import AreasHome from '../Areas/AreasHome';

export default function FacilitiesRoute() {
  const location = useLocation();
  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Route
          path="/geo-planner/areas/:areaId/facilities/:facilityId/floor-plans/:floorPlanId"
          exact
          component={FloorPlansEdit}
        />
      </DndProvider>
      <Route
        path="/geo-planner/areas/:areaId/facilities/:facilityId/floor-plans/:floorPlanId/crop"
        exact
        component={CropFloorPlan}
      />
      <Route
        path="/geo-planner/areas/:areaId/facilities/:facilityId/floor-plans"
        exact
        component={FloorPlansCreate}
      />
      {location.pathname.includes('/facilities') &&
        !location.pathname.includes('/floor-plans') && (
          <Switch>
            <Route
              path="/geo-planner/areas/:areaId/facilities/new"
              component={FacilitiesEdit}
            />
            <Route
              path="/geo-planner/areas/:areaId/facilities/:facilityId"
              component={FacilitiesEdit}
            />
          </Switch>
        )}
      {location.pathname.includes('/areas') &&
        !location.pathname.includes('/facilities') && (
          <AreasProvider>
            <Route path="/geo-planner/areas" component={AreasHome} />
          </AreasProvider>
        )}
    </>
  );
}
